import { env } from 'lib/env';

const DEFAULT_PAYLOAD_LIMIT = 100;
const envLimit = Number(env.REACT_APP_SAVE_PAYLOAD_REPORT_DATA_ITEM_LIMIT);

// use of '||' is intentinal so that default is used if value is 0
export const payloadLimitReportDataItems = Number.isNaN(envLimit) || !envLimit ? DEFAULT_PAYLOAD_LIMIT : envLimit;
